import { PropsWithChildren, ReactNode } from 'react';

import { makeStyles } from '@material-ui/core/styles';

export type SidebarContentProps = PropsWithChildren<{
  sideBarRight?: ReactNode;
  sideBarLeft?: ReactNode;
  className?: string;
}>;

const useStyles = makeStyles(
  theme => ({
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.spacing(3),
    },
    sidebar: {
      flex: '1 1 100%',
      minWidth: 0,
      [theme.breakpoints.up('md')]: {
        flex: '0 0 33.333%', // Fixed at 4/12 columns
      },
      [theme.breakpoints.up('lg')]: {
        flex: '0 0 25%', // Fixed at 3/12 columns
      },
    },
    content: {
      flex: '1 1 100%',
      minWidth: 0,
      [theme.breakpoints.up('md')]: {
        flex: '1 1 0', // Grow to fill remaining space
      },
    },
  }),
  { name: 'SidebarContent' },
);

export const SidebarContent = ({
  children,
  sideBarRight,
  sideBarLeft,
  className,
}: SidebarContentProps) => {
  const classes = useStyles();

  return (
    <div className={`${classes.container} ${className || ''}`}>
      {sideBarLeft && <div className={classes.sidebar}>{sideBarLeft}</div>}
      <div className={classes.content}>{children}</div>
      {sideBarRight && <div className={classes.sidebar}>{sideBarRight}</div>}
    </div>
  );
};
